const labelTextStyle: React.CSSProperties = {
  display: "block",
  fontSize: "14px",
  fontWeight: 600,
  marginBottom: "8px",
  color: "var(--text-primary)",
};

const textareaStyle: React.CSSProperties = {
  width: "100%",
  minHeight: "96px",
  padding: "14px 16px",
  borderRadius: "16px",
  border: "1px solid var(--border)",
  outline: "none",
  background: "var(--surface-alt)",
  color: "var(--text-primary)",
  fontSize: "15px",
  resize: "vertical",
};

export function LynxPackTextArea({
  label,
  value,
  onChange,
  rows = 4,
  helperText,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  rows?: number;
  helperText?: string;
}) {
  return (
    <label style={{ display: "block", width: "100%" }}>
      <span style={labelTextStyle}>{label}</span>

      <textarea
        value={value}
        onChange={(event) => onChange(event.target.value)}
        rows={rows}
        style={textareaStyle}
      />

      {helperText ? (
        <div
          style={{
            marginTop: "6px",
            fontSize: "12px",
            color: "var(--text-secondary)",
          }}
        >
          {helperText}
        </div>
      ) : null}
    </label>
  );
}